import React, { useState } from "react";
import "../styles/Contact.css";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.target;

    emailjs
      .sendForm(
        "service_skfddnw", // Your Service ID
        "template_ws101xp", // Your Template ID
        form,
        "v3F8JQE4HRmsGtGOV" // Your Public Key
      )
      .then(
        (result) => {
          setStatusMessage("Message sent successfully!");
          setIsSubmitting(false);
          form.reset(); // Clear the form
          setTimeout(() => setStatusMessage(null), 5000); // Hide message after 5 seconds
        },
        (error) => {
          setStatusMessage("Failed to send message. Please try again.");
          setIsSubmitting(false);
          console.error("EmailJS Error:", error.text);
          setTimeout(() => setStatusMessage(null), 5000);
        }
      );
  };

  return (
    <div className="contact-container">
      {/* Contact Heading */}
      <h2 className="contact-heading">Contact Us</h2>

      {/* Contact Image Section */}
      <div className="contact-image-container">
        <img
          src={require("../images/Contact.webp")}
          alt="Contact Us"
          className="contact-image"
        />
      </div>

      {/* Contact Details Section */}
      <div className="contact-details">
        <div className="contact-card">
          <i className="fas fa-phone"></i>
          <h3>Phone</h3>
          <p>+91 7373734618</p>
        </div>

        <div className="contact-card">
          <i className="fas fa-envelope"></i>
          <h3>Email</h3>
          <p>City.2007hosur@gmail.com</p>
        </div>

        <div className="contact-card">
          <i className="fas fa-map-marker-alt"></i>
          <h3>Address</h3>
          <p>
            559/9A, Behind VS TVS Showroom, Maruthi Nagar, Hosur, Tamil Nadu
            635109
          </p>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="contact-form-container">
        <h3>Get in Touch</h3>
        <form className="contact-form" onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Your Phone Number"
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            required
          ></textarea>
          <textarea
            name="feedback"
            placeholder="Your Feedback"
            rows="5"
          ></textarea>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Send Message"}
          </button>
          {statusMessage && <p className="status-message">{statusMessage}</p>}
        </form>
      </div>

      {/* Google Map Section */}
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243.2400385501922!2d77.85013820575725!3d12.723818684032244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae77de5a030c43%3A0x261868f3e5737968!2sCity%20Enterprises%20-%20Balmerol%2FChemoleum%20authorized%20distributor%20-Automotive%20and%20Industrial!5e0!3m2!1sen!2sin!4v1739690038073!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: 0, borderRadius: "10px" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="City Enterprises Location Map"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;